import { RTRWithdrawTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchRTRWithdrawTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);

  const [rtrWithdrawTransaction, setRTRWithdrawTransaction] = useState<RTRWithdrawTransaction>();

  async function fetchRTRWithdrawTransaction(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchRTRWithdrawTransaction({ TransactionID: transactionID }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setRTRWithdrawTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, rtrWithdrawTransaction, fetchRTRWithdrawTransaction };
}
